module.exports = __webpack_public_path__ + "assets/static/png/icon_arrow_blue.ddde9b38fefc65eaab884317c4f5f471.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myCards/images/icon_arrow_blue.png
 ** module id = 501
 ** module chunks = 1
 **/